import type { FunctionComponent } from 'react';

import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { HeaderModal } from '../../store/slices/header/types';
import { useHistorySlice } from '../../store/slices/history/selectors';
import { historyActions } from '../../store/slices/history/slice';
import { Modal } from '../modal/modal';
import { L12nText } from '../text/L12nText';

import { HistoryModalContainer } from './container';
import { HistoryFooter } from './footer/HistoryFooter';

export const HistoryModalConnected: FunctionComponent = () => {
  const dispatch = useCoreDispatch();
  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const gameInfo = useHistorySlice.getGameInfo();
  const playerInfo = useConfigSlice.playerConfig()?.screenName;

  return (
    <Modal
      open={openedModal === HeaderModal.History}
      large
      onClose={(): void => {
        dispatch(headerActions.setOpenedModal(null));
      }}
      onBack={gameInfo ? (): void => void dispatch(historyActions.setGameInfo(null)) : undefined}
      fullScreenNoClose
      floating
      draggable
      isHistoryModal
      footer={gameInfo ? <HistoryFooter /> : null}
      title={
        <>
          <L12nText tk="HISTORY" />: <span style={{ textTransform: 'none' }}>{playerInfo}</span>
        </>
      }
    >
      <HistoryModalContainer />
    </Modal>
  );
};
